export const UPDATE_COLUMN_CONFIG_FAILURE = 'UPDATE_COLUMN_CONFIG_FAILURE';

export const updateColumnConfigFailure = error => ({
    type: UPDATE_COLUMN_CONFIG_FAILURE,
    payload: error,
    error: true,
});
